import { useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A one-off confirmation message carried in navigation state from whatever
 * page redirected here (e.g. "Incident cancelled." after a delete). Pair
 * with <Toast>: `const [flash, dismissFlash] = useFlashMessage();`.
 *
 * Read once on mount, not kept in sync with location.state — so it doesn't
 * linger through a later in-page change that reuses this same state object
 * (e.g. this page's own restored filters/page), and doesn't reappear on a
 * reload, since browser history state survives those.
 */
function useFlashMessage() {
  const location = useLocation();
  const [message, setMessage] = useState(location.state?.flash || null);

  const dismiss = () => setMessage(null);

  return [message, dismiss];
}

export default useFlashMessage;
